<template>
  <form-section
    :direction="direction"
    :error="error"
    :hint="hint"
    :label="label"
    :label-visible="labelVisible"
    :name="name"
  >
    <div class="text-input__row">
      <div
        :class="{'has-file': showRemovedBtn}"
        class="text-input__input c-file-input"
      >
        <label
          :for="name"
          class="c-file-input__label"
        >
          <span>{{ theFileName }}</span>
          <input
            ref="input"
            :id="name"
            :name="name"
            :disabled="isDisabled"
            type="file"
            class="c-file-input__field"
            @change="fileChangeHandler"
          >
        </label>
        <div
          class="c-file-input__remove js-file-input__remove"
          @click.stop="clearFileHandler"
        >
          <font-awesome-icon icon="minus-circle" />
        </div>
      </div>
    </div>
  </form-section>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import InputCommon from './InputCommon'

export default {
  name: 'FileInput',
  mixins: [InputCommon],
  components: {
    FontAwesomeIcon
  },
  props: {
    labelPlaceholder: {
      type: String,
      default: 'No file choosen',
    },
    labelVisible: {
      type: Boolean,
      default: () => true
    }
  },
  data() {
    return {
      value: '',
      files: [],
      showRemovedBtn: false,
    }
  },
  computed: {
    theFileName() {
      if ((this.files.length > 0) && 'name' in this.files[0]) {
        return this.files[0].name
      }

      return this.labelPlaceholder
    },
  },
  methods: {
    fileChangeHandler(event) {
      this.files = Array.from(event.target.files)
      this.showRemovedBtn = true
      this.$emit('change', event)
    },
    clearFileHandler() {
      this.files = []
      this.showRemovedBtn = false
    }
  }
}
</script>

<style lang="sass">
@import '~styles/forms/mixins'

.c-file-input
  position: relative
  display: block
  height: rem-calc(61)

.c-file-input:invalid,
.c-field--error .c-file-input
  background-color: #ffe6e9
  border-color: #ff566a

.c-file-input:invalid:focus,
.c-field--error .c-file-input:focus
  background-color: #ffe6e9
  border-color: #ff566a

.c-file-input__label
  @include font-size(15, 48)

  position: absolute
  top: 0
  left: 0
  width: 100%
  height: 100%
  line-height: rem-calc(60)
  color: #9caba8
  overflow: hidden
  word-wrap: break-word
  z-index: 1
  cursor: pointer
  padding: rem-calc(0 20)

.c-file-input__field
  position: absolute !important
  height: 1px !important
  width: 1px !important
  padding: 0 !important
  overflow: hidden !important
  clip: rect(0, 0, 0, 0) !important
  z-index: -1

.c-file-input__field:focus
  outline: none

.c-file-input__remove
  display: none
  justify-content: center
  align-items: center
  position: absolute
  top: 0
  right: 0
  height: 100%
  width: rem-calc(61)
  z-index: 2
  cursor: pointer

  &:hover
    svg path
      fill: red

.has-file > .c-file-input__remove
  display: flex

</style>





// WEBPACK FOOTER //
// src/components/forms/FileInput.vue